/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S41_Item_3Inputs */

const es_tyc_obligations_s41_item_3 = /** @type {(inputs: Tyc_Obligations_S41_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizar las herramientas provistas por Nexata segun su documentacion.`)
};

const en_tyc_obligations_s41_item_3 = /** @type {(inputs: Tyc_Obligations_S41_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the tools provided by Nexata according to its documentation.`)
};

/**
* | output |
* | --- |
* | "Use the tools provided by Nexata according to its documentation." |
*
* @param {Tyc_Obligations_S41_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s41_item_3 = /** @type {((inputs?: Tyc_Obligations_S41_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S41_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s41_item_3(inputs)
	return en_tyc_obligations_s41_item_3(inputs)
});
export { tyc_obligations_s41_item_3 as "tyc.obligations.s41_item_3" }